import React, { useEffect, useState } from "react";
import { RtkMeeting } from "@cloudflare/realtimekit-react-ui";
import { useRealtimeKitClient, RealtimeKitProvider } from "@cloudflare/realtimekit-react";
import { isDifc } from "Routes/Routes";

const DyteMeetingVC = ({
  dyteToken,
  vcContainerStyle,
  onEnd
}) => {
  const [meeting, initClient] = useRealtimeKitClient();
  const [retryCount, setRetryCount] = React.useState(0);
  const maxRetries = 5;
  const retryDelay = 2000; // 2 seconds

  useEffect(() => {
    if (dyteToken) {
      const initializeDyteClient = async () => {
        try {
          //initialising the dyte client
          await initClient({
            authToken: dyteToken,
            // set default values for user media
            defaults: {
              audio: false,
              video: false,
            },
          });
          console.log('Dyte client initialized successfully');
          setRetryCount(0); // Reset retry count on success
        } catch (err) {
          console.error('Error initializing Dyte client:', err);
          
          // Check if it's a 404 participant not found error
          if (err.status === 404 && retryCount < maxRetries) {
            console.warn(
              `Participant not found (404). Retrying in ${retryDelay}ms... (Attempt ${retryCount + 1}/${maxRetries})`
            );
            // Retry initialization after delay
            const timeoutId = setTimeout(() => {
              setRetryCount(prevCount => prevCount + 1);
            }, retryDelay);
            return () => clearTimeout(timeoutId);
          } else if (retryCount >= maxRetries) {
            console.error('Max retries reached. Participant creation may have failed.');
            // Optionally call onEnd or set an error state
          }
        }
      };

      initializeDyteClient();
    }
    return () => {
      // window.location.reload(false)
    };
  }, [dyteToken, retryCount]);

  useEffect(() => {
    if (meeting) {
      // roomLeft now covers network drops too: the old meta "disconnected"
      // event no longer exists.
      meeting.self.on("roomLeft", () => {
        onEnd()
      });
    }
  }, [meeting]);

  return (
    <div id="vc-container" style={vcContainerStyle}>
        <RealtimeKitProvider value={meeting}>
            <RtkMeeting
                meeting={meeting}
                mode="fill"
                showSetupScreen={false}
            />
        </RealtimeKitProvider>
    </div>
  );
};
export default DyteMeetingVC;
